<div class=" flex flex-col text-base">
  <label
    [class]="labelClass"
    [ngClass]="{ 'required': required }">
    {{ label }}
  </label>

  <div class="prism-select-wrapper">
    <nz-select
      prismAddAriaLabel
      [querySelector]="ariaSelector"
      [ariaLabel]="ariaLabel"
      [formControl]="control"
      class="w-full px-1 py-1 border border-dark-purple rounded-lg bg-white text-base placeholder-dark-gray select-inside-wrapper"
      [nzPlaceHolder]="placeHolder"
      nzBorderless
      [nzDisabled]="readOnly"
      nzShowSearch
      nzServerSearch
      (nzOnSearch)="searchOptions($event)"
      (nzOnSelect)="selectOption($event)"
      [ngClass]="{ 'border-red': control.invalid && (control.dirty || control.touched) }"
      [nzMode]="multiSelect ? 'multiple' : 'default'"
      [nzDropdownClassName]="'prism-select-panel-wrap'"
      [nzDropdownMatchSelectWidth]="true"
    >
      <nz-option *ngIf="allowDeselect" [nzValue]="null" [nzLabel]="placeHolder"></nz-option>
      <nz-option-group *ngFor="let group of optionGroups" [nzLabel]="group.label">
        <nz-option
          *ngFor="let option of group.options"
          [nzValue]="option.id"
          [nzLabel]="option.name"
          [nzDisabled]="isDisabledOption(option)">
        </nz-option>
      </nz-option-group>
    </nz-select>
  </div>

  <p *ngIf="control.invalid && (control.dirty || control.touched)" class="text-sm text-red pt-1">
    {{ label }} is invalid.
  </p>
</div>